import DomUtils from '../utils/DomUtils';
import * as types from './action-types';

// Pure set overlay action. Use thunk below to actually set the overlay
export const setOverlay = (overlayID, overlayData = null) => ({
  type: types.SET_OVERLAY,
  overlayID,
  overlayData,
});

// Thunk show overlay action.
export const showOverlay = (overlayID, overlayData) => (dispatch) => {
  DomUtils.enableBodyScrollLock();
  dispatch(setOverlay(overlayID, overlayData));
};

// Pure clear overlay action. Use thunk below to actually clear the overlay
export const clearOverlay = () => ({
  type: types.CLEAR_OVERLAY,
});

export const setShouldPauseFocusTrap = shouldPauseFocusTrap => ({
  type: types.SET_SHOULD_PAUSE_FOCUS_TRAP,
  shouldPauseFocusTrap,
});

// Thunk hide overlay action
export const hideOverlay = () => (dispatch) => {
  DomUtils.disableBodyScrollLock();
  dispatch(clearOverlay());
};
